import React from "react";

const Hdg = ({ section = "", home = false, admin = false }) => {
	return home ? (
		<h1 style={{ marginBottom: "10px" }}>BFC {section ? section : ""}</h1>
	) : admin ? (
		<h1 style={{ marginBottom: "10px" }}>
			BFC Admin: {section ? section : ""}
		</h1>
	) : (
		<h1 style={{ marginBottom: "10px" }}>
			BFC Dashboard: {section ? section : ""}
		</h1>
	);
};

export default Hdg;
